'use client';

import { Accordion, Section } from '@/components/Accordion';
import CommonBreadcrumbs from '@/components/CommonBreadcrumbs';
import classes from './termsPrivacyPage.module.css';

const paths = [
  {
    text: 'Home',
    path: '/',
  },
  {
    text: 'RETURN & REFUND POLICY',
    path: '/terms-privacy',
    current: true,
  },
];

const TermsPrivacyPage = () => {
  return (
    <div className={classes.root}>
      <div className={classes.contentContainer}>
        <CommonBreadcrumbs paths={paths} />
        <div className={classes.content}>
          <h1 className={classes.title}>Terms & conditions</h1>
          <h2 className={classes.subTitile}>Overview</h2>

          <p className={classes.text}>
            This website is operated by kingsyard. Throughout the site, the terms “we”, “us” and “our” refer to
            KINGSYARD. KINGSYARD offers this website, including all information, tools and services available from this
            site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices
            stated here.
          </p>

          <p className={classes.text}>
            By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound
            by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and
            conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all
            users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/
            or contributors of content.Please read these Terms of Service carefully before accessing or using our
            website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you
            do not agree to all the terms and conditions of this agreement, then you may not access the website or use
            any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these
            Terms of Service.
          </p>

          <p className={classes.text}>
            Any new features or tools which are added to the current store shall also be subject to the Terms of
            Service. You can review the most current version of the Terms of Service at any time on this page. We
            reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or
            changes to our website. It is your responsibility to check this page periodically for changes. Your
            continued use of or access to the website following the posting of any changes constitutes acceptance of
            those changes.
          </p>

          <Accordion canOpenMultiple>
            <Section
              isOpen
              className={classes.section}
              classes={{
                root: classes.section,
                title: classes.sectionTitle,
                title_wrapper: classes.title_wrapper,
                contents_container: classes.contents_container,
              }}
              title={'Section 1 - Online store terms'}
            >
              <p className={classes.sectionText}>
                This website is operated by kingsyard. Throughout the site, the terms “we”, “us” and “our” refer to
                KINGSYARD. KINGSYARD offers this website, including all information, tools and services available from
                this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and
                notices stated here.
              </p>
            </Section>
          </Accordion>

          <Accordion canOpenMultiple>
            <Section
              isOpen
              classes={{
                root: classes.section,
                title: classes.sectionTitle,
                title_wrapper: classes.title_wrapper,
                contents_container: classes.contents_container,
              }}
              title={'Section 2 - General conditionst'}
            >
              <p className={classes.sectionText}>
                You understand that your content (not including credit card information), may be transferred unencrypted
                and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical
                requirements of connecting networks or devices. Credit card information is always encrypted during
                transfer over networks.
              </p>
            </Section>
          </Accordion>

          <Accordion canOpenMultiple>
            <Section
              isOpen
              classes={{
                root: classes.section,
                title: classes.sectionTitle,
                title_wrapper: classes.title_wrapper,
                contents_container: classes.contents_container,
              }}
              title={'Section 3 - Accuracy, completeness and timeliness of information'}
            >
              <p className={classes.sectionText}>
                We are not responsible if information made available on this site is not accurate, complete or current.
                The material on this site is provided for general information only and should not be relied upon or used
                as the sole basis for making decisions without consulting primary, more accurate, more complete or more
                timely sources of information. Any reliance on the material on this site is at your own risk.
              </p>
            </Section>
          </Accordion>

          <Accordion canOpenMultiple>
            <Section
              isOpen
              classes={{
                root: classes.section,
                title: classes.sectionTitle,
                title_wrapper: classes.title_wrapper,
                contents_container: classes.contents_container,
              }}
              title={'Section 4-AI Usage and Content Licensing'}
            >
              <div className={classes.sectionText}>
                <div>
                  Kingsyard welcomes responsible AI usage. We allow large language model (LLM) providers (such as
                  OpenAI, Anthropic, and Google) to access and use public content available on our website, including
                  blog posts, product guides, and educational resources, for the purposes of model training and
                  AI-generated answers.
                </div>

                <div className='mt-3'>This permission is granted under the condition that:</div>

                <ul className='mt-3'>
                  <li className='list-inside list-disc'>
                    No customer data, checkout, cart, or account-related pages are accessed or used.
                  </li>
                  <li className='mt-1 list-inside list-disc'>
                    Content is used in a way that respects our intellectual property and does not misrepresent our
                    brand.
                  </li>
                </ul>

                <p className='mt-3'>
                  For inquiries about content usage or licensing agreements, please contact us at&nbsp;
                  <a href='mailto:info@kingsyard.com'>info@kingsyard.com</a>.
                </p>
              </div>
            </Section>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default TermsPrivacyPage;
